// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/placeholder/content-document-placeholder.component.scss
// module id = 184
// module chunks = 0